import { Badge, BadgeSize, BadgeVariant } from "shared/components";

interface Props {
  isLast?: boolean;
  reverifyCount?: number;
  isArchived?: boolean;
}

export const IncomeReverifyTab = ({
  isLast,
  reverifyCount,
  isArchived
}: Props) => (
  <p className="text-sm">
    {isLast ? "Original verification " : `Re-verification ${reverifyCount} `}
    <Badge
      size={BadgeSize.SM}
      className="ml-1"
      variant={isArchived ? BadgeVariant.BASE : BadgeVariant.SUCCESS}
    >
      {isArchived ? "Completed" : "Active"}
    </Badge>
  </p>
);
